{
  "reports.title": "People reports",
  "reports.loadError": "We couldn’t load this report.",
  "reports.export": "Download CSV",
  "reports.exportCsv": "Export CSV",
  "reports.view.label": "Show as",
  "reports.view.chart": "Chart",
  "reports.view.table": "Table",
  "reports.nav.label": "Reports",
  "reports.nav.headcount": "Headcount & turnover",
  "reports.nav.attendance": "Attendance",
  "reports.nav.leave": "Leave",
  "reports.nav.utilization": "Utilization",
  "reports.nav.enps": "eNPS",
  "reports.nav.hiring": "Hiring funnel",
  "reports.nav.payroll": "Payroll cost",
  "reports.period.from": "From",
  "reports.period.to": "To",
  "reports.period.range": "Period (up to {count} months)",
  "reports.period.month": "Month",
  "reports.period.previousMonth": "Previous month",
  "reports.period.nextMonth": "Next month",
  "reports.period.year": "Year",
  "reports.period.yearOption": "{year}",
  "reports.columns.month": "Month",
  "reports.columns.person": "Person",
  "reports.columns.total": "Total",
  "reports.headcount.now": "Headcount now",
  "reports.headcount.headcount": "Headcount",
  "reports.headcount.hires": "Hires",
  "reports.headcount.leavers": "Leavers",
  "reports.headcount.turnover": "Turnover",
  "reports.headcount.averageTurnover": "Avg. turnover",
  "reports.headcount.chartTitle": "Headcount by month",
  "reports.headcount.chartDescription": "People employed on the last day of each month.",
  "reports.headcount.tableCaption": "Headcount, hires, leavers and turnover by month",
  "reports.headcount.departments": "By department",
  "reports.headcount.departmentsHint": "At the end of the period.",
  "reports.headcount.noDepartment": "No department",
  "reports.headcount.emptyTitle": "No headcount for this period",
  "reports.headcount.emptyBody": "Open HR records with hire dates to see headcount and turnover.",
  "reports.attendance.hint": "{days, number} workdays this month. Days by status for everyone whose attendance is tracked.",
  "reports.attendance.caption": "Attendance by person",
  "reports.attendance.workdays": "Workdays",
  "reports.attendance.present": "Present",
  "reports.attendance.remote": "Remote",
  "reports.attendance.absent": "Absent",
  "reports.attendance.paidLeave": "Paid leave",
  "reports.attendance.unpaidLeave": "Unpaid leave",
  "reports.attendance.leave": "Leave",
  "reports.attendance.missingPunch": "Missing punches",
  "reports.attendance.shortDays": "Short days",
  "reports.attendance.issues": "Issues",
  "reports.attendance.workedHours": "Worked hours",
  "reports.attendance.deductionDays": "Deduction days",
  "reports.attendance.emptyTitle": "No attendance this month",
  "reports.attendance.emptyBody": "Nobody with tracked attendance was employed this month.",
  "reports.leave.chartTitle": "Leave days in {year}",
  "reports.leave.chartDescription": "Approved leave by kind, counted in the month it starts.",
  "reports.leave.caption": "Leave days by kind and month",
  "reports.leave.kind": "Kind of leave",
  "reports.leave.days": "Days",
  "reports.leave.people": "People",
  "reports.leave.emptyTitle": "No leave this year",
  "reports.leave.emptyBody": "Approved leave shows here by kind and month.",
  "reports.utilization.chartTitle": "Utilization in {month}",
  "reports.utilization.chartDescription": "Time on the clock against time logged on work, and the billable part of it.",
  "reports.utilization.caption": "Utilization by person",
  "reports.utilization.attended": "Attended",
  "reports.utilization.logged": "Logged",
  "reports.utilization.billable": "Billable",
  "reports.utilization.attendedHours": "Attended hours",
  "reports.utilization.loggedHours": "Logged hours",
  "reports.utilization.billableHours": "Billable",
  "reports.utilization.share": "Utilization",
  "reports.utilization.billableShare": "Billable share",
  "reports.utilization.hours": "{hours} h",
  "reports.utilization.noTime": "No time recorded",
  "reports.utilization.emptyTitle": "No time this month",
  "reports.utilization.emptyBody": "Utilization shows once people clock in and log time.",
  "reports.enps.chartTitle": "eNPS by survey",
  "reports.enps.chartDescription": "From −100 to +100, oldest survey first. Only surveys with 3 or more responses count.",
  "reports.enps.survey": "Survey",
  "reports.enps.responses": "Responses",
  "reports.enps.score": "eNPS",
  "reports.enps.emptyTitle": "No eNPS yet",
  "reports.enps.emptyBody": "Run an eNPS survey; its score shows here from 3 responses.",
  "reports.hiring.chartTitle": "How far applications got",
  "reports.hiring.chartDescription": "{count, plural, one {Across # opening, applications made in the period.} other {Across # openings, applications made in the period.}}",
  "reports.hiring.caption": "Hiring funnel by opening",
  "reports.hiring.opening": "Opening",
  "reports.hiring.applied": "Applied",
  "reports.hiring.screening": "Screening",
  "reports.hiring.interview": "Interview",
  "reports.hiring.assessment": "Assessment",
  "reports.hiring.offer": "Offer",
  "reports.hiring.hired": "Hired",
  "reports.hiring.rejected": "Rejected",
  "reports.hiring.withdrawn": "Withdrawn",
  "reports.hiring.daysToHire": "Days to hire",
  "reports.hiring.emptyTitle": "No applications in this period",
  "reports.hiring.emptyBody": "Applications to your openings show here by stage.",
  "reports.payroll.chartTitle": "Net pay by month",
  "reports.payroll.chartDescription": "Locked payroll months only. Amounts in EGP.",
  "reports.payroll.caption": "Payroll cost by month, in EGP",
  "reports.payroll.people": "People",
  "reports.payroll.basic": "Basic",
  "reports.payroll.overtime": "Overtime",
  "reports.payroll.additions": "Additions",
  "reports.payroll.deductions": "Deductions",
  "reports.payroll.net": "Net",
  "reports.payroll.thousands": "{amount}K",
  "reports.payroll.emptyTitle": "No locked payroll in this period",
  "reports.payroll.emptyBody": "Payroll cost shows once a month’s payroll is locked.",
  "reports.exportExcel": "Export to Excel",
  "reports.exportExcelFailed": "We couldn't build the Excel file. Try again.",
  "reports.nav.permissions": "Permissions",
  "reports.nav.breaks": "Breaks",
  "reports.nav.balances": "Leave balances",
  "reports.nav.statutory": "Statutory leave",
  "reports.permissions.hint": "Permissions taken in the month. Time past the paid allowance is deducted.",
  "reports.permissions.caption": "Permissions by person",
  "reports.permissions.count": "Permissions",
  "reports.permissions.time": "Time",
  "reports.permissions.overQuota": "Over the quota",
  "reports.permissions.unpaid": "Unpaid time",
  "reports.permissions.emptyTitle": "No permissions this month",
  "reports.permissions.emptyBody": "Approved permissions show here per person.",
  "reports.breaks.hint": "Days flagged broke a break rule (hover for which); they are for review, never deducted.",
  "reports.breaks.caption": "Breaks by person",
  "reports.breaks.daysWorked": "Days worked",
  "reports.breaks.total": "Break time",
  "reports.breaks.average": "Average a day",
  "reports.breaks.overrunDays": "Over the allowance",
  "reports.breaks.longStretchDays": "5 h+ on end",
  "reports.breaks.missingEndDays": "Break not ended",
  "reports.breaks.longSpanDays": "Day too long",
  "reports.breaks.flaggedDays": "Days flagged",
  "reports.breaks.emptyTitle": "No breaks this month",
  "reports.breaks.emptyBody": "Breaks show here once people take them on the clock.",
  "reports.balances.hint": "Where each balance stands now, for the year chosen.",
  "reports.balances.caption": "Leave balances by person in {year}",
  "reports.balances.kindFilter": "Kind of leave",
  "reports.balances.allKinds": "All kinds",
  "reports.balances.accrued": "Earned",
  "reports.balances.granted": "Granted",
  "reports.balances.taken": "Taken",
  "reports.balances.pending": "Pending",
  "reports.balances.available": "Left",
  "reports.balances.showEmpty": "{count, plural, one {Show # empty balance} other {Show # empty balances}}",
  "reports.balances.allEmpty": "Every balance here is empty.",
  "reports.balances.emptyTitle": "No balances this year",
  "reports.balances.emptyBody": "Balances show once people have HR records and leave kinds with days.",
  "reports.statutory.law": "Statutory annual leave: 15 days a year, six of them in a row (Art. 125).",
  "reports.statutory.hint": "Those still short come first.",
  "reports.statutory.caption": "Statutory annual leave in {year}",
  "reports.statutory.entitlement": "Entitlement",
  "reports.statutory.requiredDays": "Required",
  "reports.statutory.takenDays": "Taken",
  "reports.statutory.requiredBlock": "Required in a row",
  "reports.statutory.longestBlock": "Longest in a row",
  "reports.statutory.status": "Status",
  "reports.statutory.met": "Met",
  "reports.statutory.notMet": "Not met",
  "reports.statutory.daysLeft": "{count, plural, one {# day left} other {# days left}}",
  "reports.statutory.blockLeft": "{count, plural, one {# day in a row owed} other {# days in a row owed}}",
  "reports.statutory.daysShort": "{count, plural, one {# day short} other {# days short}}",
  "reports.statutory.blockShort": "Days in a row owed",
  "reports.statutory.unmet": "Not met yet",
  "reports.statutory.unmetNone": "Everyone",
  "reports.statutory.ofPeople": "{count, plural, one {of # person} other {of # people}}",
  "reports.statutory.metCount": "Met",
  "reports.statutory.emptyTitle": "Nobody to check this year",
  "reports.statutory.emptyBody": "People with annual leave show here."
}
